module.exports = __webpack_public_path__ + "static/media/next-page.3a44b459.svg";